"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var Friends = function Friends(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2["default"])({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), (0, _core.jsx)("path", {
    d: "M21.386 18.257l-7.697-.002a.308.308 0 01-.306-.293 2.967 2.967 0 00-.525-1.721.396.396 0 01.159-.613l.024-.009c1.335-.503 1.795-1 1.874-2.231a2.9 2.9 0 01-.618-.543 2.987 2.987 0 01-.587-1.463.426.426 0 01-.045.003c-.334 0-.587-.715-.587-1.219 0-.503.172-.656.335-.656.035 0 .066.002.097.005a4.302 4.302 0 01-.122-.966c0-1.22.337-2.064 1.366-2.214.57-.402 1.43-.579 2.53-.579.704 0 .117.49.778.632.41.088 1.172.383 1.172 2.161-.004.326-.045.65-.122.966.03-.003.062-.005.096-.005.164 0 .336.153.336.656 0 .504-.253 1.22-.587 1.22a.427.427 0 01-.045-.004 2.986 2.986 0 01-.587 1.463 2.89 2.89 0 01-.612.538c.078 1.235.538 1.732 1.875 2.236 1.392.526 2.026.887 2.107 2.303a.319.319 0 01-.084.235.309.309 0 01-.225.1zm-16.306-5c-.38 0-1.54-.958-1.54-3.25 0-2.686 1.52-4.25 3.335-4.25.869 0 1.278.04 1.744.468 1.33 0 2.616 1.002 2.616 3.782 0 2.275-1.147 3.25-1.539 3.25-.136 0-.24-.12-.393-.279a3.105 3.105 0 01-.513.419c.08 1.225.542 1.72 1.875 2.222 1.394.526 2.028.887 2.11 2.303a.319.319 0 01-.084.235.309.309 0 01-.226.1H2.313a.309.309 0 01-.225-.1.319.319 0 01-.084-.235c.081-1.415.715-1.777 2.109-2.303 1.333-.502 1.794-.996 1.875-2.22a3.104 3.104 0 01-.518-.423c-.154.159-.257.282-.39.282z",
    fill: "currentColor"
  }));
};

var _default = (0, _react.forwardRef)(Friends);

var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Friends, "Friends", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Friends.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Friends.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();